var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_car",
    "data-name": "icon car",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20064",
    "data-name": "Path 20064",
    d: "M1.393-8.831,2.63-12.365a3.374,3.374,0,0,1,3.185-2.26h6.37a3.375,3.375,0,0,1,3.185,2.26l1.238,3.534A2.254,2.254,0,0,1,18-6.75V0a1.124,1.124,0,0,1-1.125,1.125H15.75A1.124,1.124,0,0,1,14.625,0V-1.687H3.375V0A1.124,1.124,0,0,1,2.25,1.125H1.125A1.124,1.124,0,0,1,0,0V-6.75A2.252,2.252,0,0,1,1.393-8.831ZM3.836-9H14.164l-.918-2.623a1.126,1.126,0,0,0-1.062-.752H5.815a1.126,1.126,0,0,0-1.062.752L3.836-9ZM3.375-6.75A1.124,1.124,0,0,0,2.25-5.625,1.124,1.124,0,0,0,3.375-4.5,1.124,1.124,0,0,0,4.5-5.625,1.124,1.124,0,0,0,3.375-6.75ZM14.625-4.5A1.124,1.124,0,0,0,15.75-5.625,1.124,1.124,0,0,0,14.625-6.75,1.124,1.124,0,0,0,13.5-5.625,1.124,1.124,0,0,0,14.625-4.5Z",
    transform: "translate(3 19)",
    fill: "#4877ce"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSelected);
export default __webpack_public_path__ + "static/media/car-selected.cac005d5988ac6bae41e8c3f03a65983.svg";
export { ForwardRef as ReactComponent };